import styled from 'styled-components';
import {rem} from 'polished';

const Wrapper = styled.div`
    display: flex;
    gap: ${rem(46)}
`;

export default Wrapper;